import { render } from "./MessageTemplate.vue?vue&type=template&id=a4cdcb84"
import script from "./MessageTemplate.vue?vue&type=script&lang=js"
export * from "./MessageTemplate.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MessageTemplate.vue?vue&type=style&index=0&id=a4cdcb84&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__